import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'

import AddBoxIcon from '@mui/icons-material/AddBox'
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type AccordionProps = {
  children?: React.ReactNode
  title: string
}

const AccordionSummary = styled(MuiAccordionSummary)({
  backgroundColor: colors.gray100,
  '&.Mui-expanded': {
    minHeight: '54px'
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'none',
  },
  '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
    margin: '15px 0'
  }
})

const AccordionDetails = styled(MuiAccordionDetails)({
  backgroundColor: colors.gray50
})

export function Accordion(props: AccordionProps) {
  const { children, title } = props
  const [expanded, setExpanded] = useState<boolean>(false)

  const handleChange = (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded)
  }

  return (
    <MuiAccordion
      expanded={expanded}
      onChange={handleChange}
    >
      <AccordionSummary
        expandIcon={expanded ? <IndeterminateCheckBoxIcon color="primary" /> : <AddBoxIcon color="primary" />}
      >
        <Typography>
          {title}
        </Typography>
      </AccordionSummary>
      {!!children && (
        <AccordionDetails>
          {children}
        </AccordionDetails>
      )}
    </MuiAccordion>
  )
}

export default Accordion